/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Nexata_List_Files_On_Thread_SuccessInputs */

const es_tools_nexata_list_files_on_thread_success = /** @type {(inputs: Tools_Nexata_List_Files_On_Thread_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Archivos del hilo listados`)
};

const en_tools_nexata_list_files_on_thread_success = /** @type {(inputs: Tools_Nexata_List_Files_On_Thread_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thread files listed`)
};

/**
* | output |
* | --- |
* | "Thread files listed" |
*
* @param {Tools_Nexata_List_Files_On_Thread_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_nexata_list_files_on_thread_success = /** @type {((inputs?: Tools_Nexata_List_Files_On_Thread_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Nexata_List_Files_On_Thread_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_nexata_list_files_on_thread_success(inputs)
	return en_tools_nexata_list_files_on_thread_success(inputs)
});
export { tools_nexata_list_files_on_thread_success as "tools.nexata.list_files_on_thread_success" }